module.exports = __webpack_public_path__ + "static/media/gmail-new-mail-correct.774048c5.png";